<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="card my-profile-form margin-top-15px top-link color-#B3B9BE" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-0px height-50px bk-lt-gray">
      <div class="row">
        <div class="col-md-1 margin-top-3px padding-left-12px">
          Patients
        </div>
        <div class="col-md-4">
          <div class="row">
            <div>
              <label class="margin-right-3px margin-bottom-0px font-size-16px margin-top-6px">Branch :</label>
            </div>
            <div class="form-group padding-right-10px">
              <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                       (keyChange)="Branchdata($event)"
                                       [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                       required>
              </CustomDataByRequestType>
            </div>            
              <div hidden>
                <label class="margin-right-10px margin-bottom-0px font-size-16px">
                  <input type="radio" class="margin-right-3px" [(ngModel)]="Selectedtoday" name="sameName" id="nameA" value="nameA" (change)="onSubmit2($event)"> Today
                </label>
              </div>
              <div class="" hidden>
                <div class=" margin-bottom-0px font-size-16px margin-top-3px margin-right-10px">

                  <input type="radio" class="margin-right-3px" [(ngModel)]="SelectedDuration" name="sameName" id="nameB" value="nameB" (change)="onSubmit($event)"> Duration


                </div>
              </div>
              <div *ngIf="isdisplaydate" hidden>
                <label class="margin-right-3px margin-bottom-0px font-size-16px margin-left-3px">From :</label>
              </div>
              <div class="width-14pe margin-right-10px" *ngIf="isdisplaydate" hidden>
                <div class="date-form">
                  <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new padding-top-4px" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedFrom" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker">

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon margin-top-2px"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>
              </div>
              <div *ngIf="isdisplaydate" class="margin-top-2px" hidden>
                <label class="margin-right-3px margin-bottom-0px font-size-16px">To :</label>
              </div>
              <div class="width-14pe" *ngIf="isdisplaydate">
                <div class="date-form">
                  <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new padding-top-4px" placeholder="To Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedTo" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker">

                  <a (click)="d1.toggle()" class="nav-link-hand">
                    <span class="date-icon margin-top-2px"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>
              </div>
              <div class="width-0pe" hidden>
                <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-10px" (click)="Go()">Go</button>
              </div>

            </div>
          </div>
        <div class="col-md-2">
          <div class="form-group margin-bottom-5px">
            <div class="row">
              <div (click)="DecrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                <a title="Previous" class="nav-link-hand">
                  <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
                </a>
              </div>
              <div class="col-md-9 col-sm-4 padding-left-10px padding-right-9px">
                <div class="date-form">
                  <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-15px font-weight-bold data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="SelectedToDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d="ngbDatepicker"
                         (ngModelChange)="dataChanged($event)">
                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                  </a>
                </div>
              </div>
              <div (click)="IncrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                <a title="Next" class="nav-link-hand">
                  <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row float-right">
            <div class="col-md-6 padding-right-0px text-align-right">
              <a *canUserAccess="['HL_REG_10']"
                 (click)="AddNewEnquiry()"
                 class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-300"
                 title="Click here for New Enquiry">
                <i class="fas fa-plus font-size-11 margin-right-3px"></i>Enquiry
              </a>
              <a (click)="AddNewPatient()"
                 class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-300"
                 title="Click here for New Registration">
                <i class="fas fa-plus font-size-11 margin-right-3px"></i>Register
              </a>
            </div>
            <div class="col-md-6 padding-right-0px padding-l-0px display-inherit">
              <form novalidate="" #f="ngForm" class="display-inherit">
                <div class="clear-form">
                  <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                  <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                </div>
                <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime Go-button margin-right-auto margin-left-5px">Find</button>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-1">
          <button type="button" class="btn  btn-raised  broder-primary margin-right-5px  button-Schedule font-size-14p padding-left-6px padding-right-6px padding-top-3px border-all-0px" (click)="DisplayStyle('List')"><i class="fas fa-list"></i></button>
          <button type="button" class="btn  btn-raised  broder-primary   button-Schedule font-size-18px padding-left-6px padding-right-6px padding-top-3px border-all-0px" (click)="DisplayStyle('Card')"><i class="fas fa-id-badge"></i></button>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component" *ngIf="DisplayTable">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>
                    <th class="min-width-24px">
                      #
                    </th>
                    <th class="">
                      PID
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                      Old Reg No
                    </th>-->
                    <th class="">
                      Name
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="">
                      Reg Date
                    </th>

                    <!--<th class="">
                      Prime Relation
                    </th>-->

                    <th class="">
                      Contact
                    </th>
                    <th class="">
                      Sex
                    </th>
                    <th class="">Age</th>

                    <th>Marital </th>
                    <th>Category</th>
                    <th></th>



                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr *ngFor="let l of CurrentPatientInfoByFormattedCodeController; let RowIndex = index ">
                    <td class="td-padding-tb">
                      {{RowIndex+1}}
                    </td>
                    <td class="td-padding-tb"> <a (click)="ViewPatientDetails(l)" class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i>{{l.FormattedCode}}</a>  </td>
                    <!--<td class="td-padding text-align-center">Mon</td>-->
                    <!--<td class="td-padding text-align-center">

                      {{l.PatientRegistrationNumber}}
                    </td>-->
                    <td class=" td-padding-tb">{{l.DisplayName}}</td>
                    <!--<td class="td-padding text-align-center"></td>-->
                    <td class=" td-padding-tb">{{l.RegistrationDate| date:'MMM-dd-yyyy'}}</td>
                    <!--<td class=" td-padding-tb ">{{l.PrimeRelation}}</td>-->

                    <td class="td-padding-tb">{{l.Telephone1}}</td>
                    <td class="td-padding-tb ">{{l.Gender}}</td>
                    <td class=" td-padding-tb ">{{l.Age}}</td>

                    <td class="td-padding-tb">{{l.MaritalStatus}}</td>
                    <td class="td-padding-tb">{{l.PatientCategory}}</td>
                    <td class="td-padding-tb">
                      <div *canUserAccess="['DeletePatient']">
                        <a class="nav-link-hand font-size-12px color-Rejected" title="Remove" (click)="DeletePatient(l)">
                          <i class="far fa-trash-alt nav-link-hand"></i>
                        </a>
                      </div>
                    </td>


                    <!--<td class="td-padding-tb">
                      <div class="row">
                        <a (click)="edit_(l)" class="nav-link-hand education-navlink" title="edit">
                          <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                        </a>
                        <a (click)="del_(l.EducationCode)" class="nav-link-hand education-navlink" title="Remove">
                          <span class="badge">
                            <i class="far fa-trash-alt"></i>
                          </span>
                        </a>

                      </div>
                    </td>-->



                  </tr>

                </tbody>

              </table>
            </div>
          </div>

          <div *ngIf="DisplayCard" class="row">
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 padding-top-6px margin-bottom-15px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController; let RowIndex = index ">

              <div class="card height-100pe profile-card-border border-effect">
                <div class="card-body padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px margin-left-0px">

                  <div class="background-hover-lightblue text-align-center">
                    <div [ngSwitch]="l.RegistrationReason" class="text-align-center margin-bottom-5px">
                      <a data-toggle="tooltip" data-placement="bottom" title="SURGT">
                        <img *ngSwitchCase="'SURGT'" class="img-circle-40" src="Surrogate.png">
                      </a>
                      <a data-toggle="tooltip" data-placement="bottom" title="EGG">
                        <img *ngSwitchCase="'EGG'" class="img-circle-40" src="Egg.png">
                      </a>
                      <a data-toggle="tooltip" data-placement="bottom" title="SEMEN">
                        <img *ngSwitchCase="'SEMEN'" class="img-circle-40" src="Semen.png">
                      </a>
                    </div>
                    <div class="patient-avatar-wrapper">
                      <svg class="patient-avatar-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="8" r="4.5" fill="#0078D4"/>
                        <path d="M4 19C4 15.6863 7.58172 13 12 13C16.4183 13 20 15.6863 20 19V20H4V19Z" fill="#0078D4"/>
                      </svg>
                    </div>
                    <div class="patient-name-title">{{l.DisplayName}}</div>
                    <div class="text-align-center">
                      <span class="patient-code-subtitle">{{l.FormattedCode}}</span>
                    </div>
                  </div>

                  <div class="background-color-wt div-show-effect-parent">
                    <div class="patient-stats-row">
                      <div class="patient-stat-item">
                        <p class="patient-stat-val">{{l.Age}}</p>
                        <p class="patient-stat-lbl">Age</p>
                      </div>
                      <div class="patient-stat-item">
                        <p class="patient-stat-val">{{l.Gender}}</p>
                        <p class="patient-stat-lbl">Sex</p>
                      </div>
                      <div class="patient-stat-item">
                        <p class="patient-stat-val">{{l.PatientCategory}}</p>
                        <p class="patient-stat-lbl">Category</p>
                      </div>
                    </div>

                    <div class="patient-card-actions show-child-on-parent-over">
                      <a class="patient-action-btn action-adv nav-link-hand"
                         title="New Advance" (click)="AddAdv(l)">+A</a>
                      <a *canUserAccess="['HL_BL_30']"
                         class="patient-action-btn action-bill nav-link-hand"
                         title="New OP Bill" (click)="Addbill_withSvcProvider(l)">+B</a>
                      <a class="patient-action-btn action-rx nav-link-hand"
                         title="New RX Bill" (click)="AddRxbill(l)">Rx</a>
                      <a class="patient-action-btn action-profile nav-link-hand"
                         title="Open Patient Profile" (click)="ViewPatientDetails(l)">
                        <i class="far fa-folder-open font-size-13px"></i>
                      </a>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-md-12 background-height" *ngIf="!ShowList">

  <ul class="nav nav-tabs nav-tab-service2" id="tabContent" *ngIf="HasPartnerData">
    <li class="active margin-right-15px padding-top-15px"><a class="nav-itemerp active" href="#primaryprofile" data-toggle="tab">Selected Actor</a></li>
    <li *ngIf="HasPartnerData"
        class="margin-right-15px padding-top-15px" ><a class="nav-itemerp" href="#partnerprofile" data-toggle="tab">Partner</a></li>
  </ul>

  <div class="tab-content">
    <div class="tab-pane active" id="primaryprofile">
      <profileview (GoBack)="OnGoBack()"
                   [FormattedCode]="SelectedPatient.FormattedCode" [DisplayName]="SelectedPatient.DisplayName" *ngIf="ShowPatientDetails"></profileview>

    </div>

    <div *ngIf="ShowPatientDetails" class="tab-pane" id="partnerprofile">     
      <profileviewpartner (GoBack)="OnGoBack()"
               [FormattedCode]="PartnerFormattedCode" [DisplayName]="PartnerDisplayName"
                   *ngIf="HasPartnerData"></profileviewpartner>


    </div>
  </div>
 </div>
    <div class="card my-profile-form margin-top-15px top-link2">
      <div class="card-header wh-header padding-bottom-6px padding-top-6px">
        <div class="row">
          <div class="col-md-3 col-3 font-size-16px margin-top-5px">
            Patients
          </div>
          <!--<div class="col-md-8 col-8 padding-right-0px">
          <div class="row">
            <div class="offset-md-6 col-md-2 padding-right-0px text-align-center">
              <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
            </div>
            <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
              <form novalidate="" #f="ngForm" class="display-inherit">
                <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue'>
                <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
              </form>
            </div>
          </div>
        </div>-->
          <div class="col-3 text-align-right-small padding-left-0px">
            <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link  margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
          </div>
          <div class="col-6 float-right padding-right-0px padding-l-0px display-inherit">
            <form novalidate="" #f="ngForm" class="display-inherit">
              <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchText" name="searchBar" [value]='searchText'>
              <button (click)="criteriaChange2(searchText)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
            </form>
          </div>

          <!--<div class="col-4">
          <form novalidate="" #f="ngForm" class="display-inherit">
            <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue'>
            <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
          </form>
        </div>-->
        </div>

      </div>
      <div class="card-body padding-top-0px margin-left-0px padding-left-0px">

        <!--<div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>

                    <th class="">
                      PID
                    </th>

                    <th class="">
                      Name
                    </th>

                    <th class="">
                      Reg Date
                    </th>

                    <th class="">
                      Prime Relation
                    </th>

                    <th class="">
                      Contact
                    </th>
                    <th class="">
                      Sex
                    </th>
                    <th class="">Age</th>

                    <th>Marital </th>
                    <th>Category</th>



                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr *ngFor="let l of CurrentPatientInfoByFormattedCodeController">

                    <td class="td-padding-tb"> <a (click)="ViewPatientDetails(l)" class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i>{{l.FormattedCode}}</a>  </td>

                    <td class=" td-padding-tb">{{l.DisplayName}}</td>

                    <td class=" td-padding-tb">{{l.RegistrationDate| date:'MMM-dd-yyyy'}}</td>
                    <td class=" td-padding-tb ">{{l.PrimeRelation}}</td>

                    <td class="td-padding-tb">{{l.Telephone1}}</td>
                    <td class="td-padding-tb ">{{l.Gender}}</td>
                    <td class=" td-padding-tb ">{{l.Age}}</td>

                    <td class="td-padding-tb">{{l.MaritalStatus}}</td>
                    <td class="td-padding-tb">{{l.PatientCategory}}</td>






                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>-->
        
        <div class="row border-bottom row-for-scans margin-left16px nav-link-hand box-shadow-new-treatmentcycle margin-right-0px margin-bottom-5px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
          
          <div class="col-md-2 col-2 padding-left-0px margin-top-5px">





        <!--<img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">-->

            <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">

          </div>
          <div class="col-md-7 col-7 margin-top-5px margin-bottom-5px padding-right-0px padding-left-0px">
            <div class="row row-height-17px">
              <div class="col-md-12 col-12">
                <label class="margin-bottom-0px">{{l.DisplayName}}</label>
              </div>

            </div>
            <div class="row row-height-17px">
              <div class="col-md-12 col-12">
                <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.Age}},{{l.FormattedCode}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-4 col-4">
                <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.Telephone1}}</label>
              </div>
            </div>

          </div>
          <div class="col-md-3  col-3 padding-left-0px margin-top-auto margin-bottom-auto">
            <div class="text-align-center">

              <button class="btn  btn-camera2" (click)="capture(l)"><i class="fas fa-camera"></i></button>

            </div>

          </div>
        </div>
      </div>
    </div>
